import { customElement, property, state } from 'lit/decorators.js'
import { css, CSSResultGroup, html, LitElement } from 'lit'
import { styleMap } from 'lit/directives/style-map.js'
import { consume } from '@lit/context'
import { productTileProductContext } from 'components/discovery/product/tile-parts/tile-product-context.js'
import { InternalProduct, ProductModel } from 'components/discovery/product/tile-parts/tile-parts-typing.js'
import { partsStyle } from 'components/discovery/product/tile-parts/tile-parts.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'

export const fontVariants = ['product-title-s', 'product-title-m', 'product-title-l'] as const
export type fontVariantsType = typeof fontVariants

const tileTitleStyle = css`
  :host {
    --cse-link-secondary-color: var(--cs-font-product-title-m-color);
  }
`

@customElement('csc-product-tile-title')
export class CSCProductTileTitle extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, partsStyle, tileTitleStyle]

  @property({ type: String, attribute: 'font-variant' })
  fontVariant: fontVariantsType[number] = 'product-title-m'

  @consume({ context: productTileProductContext })
  @state()
  product: InternalProduct = new ProductModel().parseToInternal()

  override render() {
    const size = this.fontVariant.replace('product-title-', '')

    return html`
      <cse-link
        url="${this.product.pageLink}"
        variant="secondary"
        font-variant="${this.fontVariant}"
        style=${styleMap({ '--cse-link-secondary-color': `var(--cs-font-product-title-${size}-color)` })}
      >
        ${this.product.name}
      </cse-link>
    `
  }
}
